// One event layer for campaign pages (page-tracking skill). Extra only: never replaces a tool's own tracking.
// Click tracking: data-track="bird_dog_pick" data-track-dog="lab". Other events: window.track('name', {props}).
// Props describe WHAT happened, never WHO: no email, phone, name or code.
// Consent: Shopify's cookie banner decides. Declined = nothing leaves the browser (only the local test log).
// Later: Jan's collector (/apps/t) replaces the direct sends; pages and tags stay the same.
(function () {
  if (window.track) return;
  var log = (window.__track = window.__track || []);

  function allowed(kind) {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return true; // no consent API on the page: each tool's own consent handling still applies
      return kind === 'marketing' ? cp.marketingAllowed() : cp.analyticsProcessingAllowed();
    } catch (e) { return true; }
  }

  function track(name, props) {
    props = props || {};
    log.push({ name: name, props: props, t: Date.now() });
    if (allowed('analytics')) {
      try { if (window.clarity) { window.clarity('event', name); for (var k in props) window.clarity('set', name + '_' + k, String(props[k])); } } catch (e) {}
      try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish(name, props); } catch (e) {}
    }
    if (allowed('marketing')) {
      try { if (window.klaviyo && window.klaviyo.track) window.klaviyo.track(name, props); } catch (e) {}
    }
  }
  window.track = track;

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-track]');
    if (!el) return;
    var props = {};
    for (var i = 0; i < el.attributes.length; i++) {
      var a = el.attributes[i];
      if (a.name.indexOf('data-track-') === 0) props[a.name.slice(11)] = a.value;
    }
    track(el.getAttribute('data-track'), props);
  }, true);
})();
